<!-- 查勘项目管理 -->
<template>
    <div class="app-container">
        <!-- 搜索栏 -->
        <el-card shadow="hover" class="search-card" ref="filterForm">
            <el-form :inline="true" size="small" @keyup.enter.native="toFilter">
                <el-form-item label="项目名称">
                    <el-input v-model="filter.name" placeholder="请输入" clearable style="width: 170px;"></el-input>
                </el-form-item>
                <el-form-item label="项目类型">
                    <el-select v-model="filter.project_type" placeholder="请选择" clearable style="width: 150px;">
                        <el-option v-for="t in projectTypeOptions" :key="t.id" :label="t.name" :value="t.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属社区">
                    <el-select v-model="filter.community_id" placeholder="请选择" clearable filterable style="width: 170px;">
                        <el-option v-for="c in communityOptions" :key="c.ID" :label="c.name" :value="c.ID"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="创建时间">
                    <el-date-picker v-model="filter.dateRange" type="daterange" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"
                        style="width: 240px;"></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button icon="el-icon-search" type="primary" @click="toFilter">查询</el-button>
                    <el-button icon="el-icon-plus" type="success" @click="addProject"
                        v-permision_tjtf="'add'">新增项目</el-button>
                </el-form-item>
            </el-form>
        </el-card>

        <!-- 统计区（按当前搜索条件汇总，不含分页） -->
        <el-card shadow="hover" class="stat-card" v-loading="statLoading" v-if="false">
            <div class="stat-item" v-for="s in statItems" :key="s.key">
                <span class="stat-label">{{ s.label }}</span>
                <span class="stat-value">{{ statData[s.key] != null && statData[s.key] !== '' ? statData[s.key] : '-' }}</span>
            </div>
        </el-card>

        <!-- 表格 -->
        <el-card shadow="hover" class="table-card">
            <el-table :data="tableData" :border="true" stripe highlight-current-row :current-row-key="selectedRowKey"
                row-key="id" style="width: 100%;" height="calc(100vh - 430px)" @row-click="handleRowClick"
                v-loading="loading">
                <el-table-column label="序号" type="index" width="60" :align="tableColumnAlign" fixed="left"></el-table-column>
                <el-table-column prop="name" label="项目名称" min-width="160" show-overflow-tooltip fixed="left"></el-table-column>
                <el-table-column label="项目类型" width="130" :align="tableColumnAlign">
                    <template slot-scope="scope">{{ scope.row.project_type_name || getTypeName(scope.row.project_type) }}</template>
                </el-table-column>
                <el-table-column label="所属社区" width="140" :align="tableColumnAlign">
                    <template slot-scope="scope">{{ getCommunityName(scope.row.community_id || scope.row.community_name) }}</template>
                </el-table-column>
                <el-table-column prop="transformer_type" label="变压器类型" width="100" :align="tableColumnAlign"></el-table-column>
                <el-table-column prop="transformer_ground" label="地面变压器数量" width="130" :align="tableColumnAlign"></el-table-column>
                <el-table-column prop="transformer_down_ground" label="地下车库变压器数量" width="150" :align="tableColumnAlign"></el-table-column>
                <el-table-column prop="building_count" label="住宅栋数（栋）" width="120" :align="tableColumnAlign"></el-table-column>
                <el-table-column prop="house_total" label="规划总户数（户）" width="130" :align="tableColumnAlign"></el-table-column>
                <el-table-column prop="house_occupied" label="入住户数（户）" width="120" :align="tableColumnAlign"></el-table-column>
                <el-table-column prop="park_up_cout" label="地面车位数（个）" width="120" :align="tableColumnAlign"></el-table-column>
                <el-table-column prop="park_down_cout" label="地下车位数（个）" width="120" :align="tableColumnAlign"></el-table-column>
                <el-table-column prop="park_solded_count" label="已售车位数（个）" width="120" :align="tableColumnAlign"></el-table-column>
                <el-table-column prop="vehicle_total" label="车辆总数（台）" width="120" :align="tableColumnAlign"></el-table-column>
                <el-table-column prop="vehicle_ev_total" label="电动汽车总数（台）" width="130" :align="tableColumnAlign"></el-table-column>
                <el-table-column prop="cabinet_count" label="负控一体柜数量" width="120" :align="tableColumnAlign"></el-table-column>
                <el-table-column prop="branch_box_count" label="分支箱数量" width="110" :align="tableColumnAlign"></el-table-column>
                <el-table-column prop="charge_pile_count" label="充电桩数量" width="110" :align="tableColumnAlign"></el-table-column>
                <el-table-column prop="total_amount" label="总金额" width="120" :align="tableColumnAlign"></el-table-column>
                <el-table-column prop="create_time" label="创建时间" width="170" :align="tableColumnAlign"></el-table-column>
                <el-table-column label="操作" width="150" :align="tableColumnAlign" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="detailsProject(scope.row)">详情</el-button>
                        <el-button type="text" size="small" @click="updateProject(scope.row)" v-permision_tjtf="'edit'">修改</el-button>
                        <el-button type="text" size="small" @click="deleteProject(scope.row)" v-permision_tjtf="'delete'">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <div class="my-pagination">
                <el-pagination background layout="sizes,total,prev,pager,next,jumper" :total="pageParams.total"
                    :page-size="pageParams.limit" :page-sizes="[5, 10, 50, 100, 500, 1000]"
                    :current-page="pageParams.page" @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"></el-pagination>
            </div>
        </el-card>

        <!-- 4.2 项目新增/修改 Drawer -->
        <el-drawer :title="projectDrawerTitle" :visible.sync="projectDrawerVisible" direction="rtl" size="60%"
            @closed="resetProjectForm">
            <div class="drawer-body">
                <el-form :model="projectForm" :rules="projectFormRules" ref="projectForm" label-width="140px">
                    <el-divider content-position="left">基础信息（必填）</el-divider>
                    <el-form-item label="项目名称" prop="name">
                        <el-input v-model="projectForm.name" placeholder="请输入项目名称" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="项目类型" prop="project_type">
                        <el-select v-model="projectForm.project_type" placeholder="请选择" clearable style="width: 100%;"
                            @change="onProjectTypeChange">
                            <el-option v-for="t in projectTypeOptions" :key="t.id" :label="t.name" :value="t.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="项目归属社区" prop="community_id">
                        <el-select v-model="projectForm.community_id" placeholder="请选择" clearable filterable
                            style="width: 100%;" @change="onCommunityChange">
                            <el-option v-for="c in communityOptions" :key="c.ID" :label="c.name" :value="c.ID"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-divider content-position="left">其他属性（选填）</el-divider>
                    <el-form-item label="变压器类型">
                        <el-select v-model="projectForm.transformer_type" placeholder="请选择" clearable style="width: 100%;">
                            <el-option label="公变" value="公变"></el-option>
                            <el-option label="私变" value="私变"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="小区地面变压器数量（台）">
                        <el-input v-model.number="projectForm.transformer_ground" type="number" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="地下车库变压器数量（台）">
                        <el-input v-model.number="projectForm.transformer_down_ground" type="number" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="住宅栋数（栋）">
                        <el-input v-model.number="projectForm.building_count" type="number" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="小区规划总户数（户）">
                        <el-input v-model.number="projectForm.house_total" type="number" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="当前入住户数（户）">
                        <el-input v-model.number="projectForm.house_occupied" type="number" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="地面车位数（个）">
                        <el-input v-model.number="projectForm.park_up_cout" type="number" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="地下车库车位数（个）">
                        <el-input v-model.number="projectForm.park_down_cout" type="number" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="已售车位数（个）">
                        <el-input v-model.number="projectForm.park_solded_count" type="number" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="车辆总数（台）">
                        <el-input v-model.number="projectForm.vehicle_total" type="number" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="电动汽车车辆总数（台）">
                        <el-input v-model.number="projectForm.vehicle_ev_total" type="number" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="备注">
                        <el-input v-model="projectForm.remark" type="textarea" :rows="3" placeholder="请输入备注"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="submitProject">保存</el-button>
                        <el-button @click="projectDrawerVisible = false">取消</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-drawer>

        <!-- 4.4 项目详情 Drawer -->
        <el-drawer title="项目详情" :visible.sync="detailDrawerVisible" direction="rtl" size="70%" @closed="closeDetail">
            <div class="drawer-body" v-if="detailData && detailData.ID">
                <!-- 顶部三行基础信息 -->
                <el-descriptions :column="3" border size="small" class="detail-desc">
                    <el-descriptions-item label="项目名称">{{ detailData.name }}</el-descriptions-item>
                    <el-descriptions-item label="项目类型">{{ detailData.project_type_name || getTypeName(detailData.project_type) }}</el-descriptions-item>
                    <el-descriptions-item label="所属社区">{{ getCommunityName(detailData.community_id || detailData.community_name) }}</el-descriptions-item>
                </el-descriptions>

                <el-tabs v-model="detailActiveTab" class="detail-tabs">
                    <!-- 项目详情 -->
                    <el-tab-pane label="项目详情" name="info">
                        <el-descriptions :column="2" border size="small">
                            <el-descriptions-item label="变压器类型">{{ detailData.transformer_type || '-' }}</el-descriptions-item>
                            <el-descriptions-item label="创建时间">{{ detailData.create_time || '-' }}</el-descriptions-item>
                            <el-descriptions-item label="地面变压器数量（台）">{{ detailData.transformer_ground || 0 }}</el-descriptions-item>
                            <el-descriptions-item label="地下车库变压器数量（台）">{{ detailData.transformer_down_ground || 0 }}</el-descriptions-item>
                            <el-descriptions-item label="住宅栋数（栋）">{{ detailData.building_count || 0 }}</el-descriptions-item>
                            <el-descriptions-item label="小区规划总户数（户）">{{ detailData.house_total || 0 }}</el-descriptions-item>
                            <el-descriptions-item label="当前入住户数（户）">{{ detailData.house_occupied || 0 }}</el-descriptions-item>
                            <el-descriptions-item label="地面车位数（个）">{{ detailData.park_up_cout || 0 }}</el-descriptions-item>
                            <el-descriptions-item label="地下车库车位数（个）">{{ detailData.park_down_cout || 0 }}</el-descriptions-item>
                            <el-descriptions-item label="已售车位数（个）">{{ detailData.park_solded_count || 0 }}</el-descriptions-item>
                            <el-descriptions-item label="车辆总数（台）">{{ detailData.vehicle_total || 0 }}</el-descriptions-item>
                            <el-descriptions-item label="电动汽车车辆总数（台）">{{ detailData.vehicle_ev_total || 0 }}</el-descriptions-item>
                            <el-descriptions-item label="备注" :span="2">{{ detailData.remark || '-' }}</el-descriptions-item>
                        </el-descriptions>
                    </el-tab-pane>

                    <!-- 点位列表（4.5） -->
                    <el-tab-pane label="点位列表" name="point">
                        <div class="point-toolbar">
                            <el-breadcrumb separator="/">
                                <el-breadcrumb-item><a @click="goPointRoot(detailData.ID)">项目根</a></el-breadcrumb-item>
                                <el-breadcrumb-item v-for="(b, i) in pointBreadcrumb" :key="b.ID">
                                    <a @click="goPointLevel(i)">{{ (b.father_name || '电表') + '至' + b.name }}</a>
                                </el-breadcrumb-item>
                            </el-breadcrumb>
                            <el-button type="primary" size="small" icon="el-icon-plus" @click="openPointForm()"
                                v-permision_tjtf="'add'">添加点位</el-button>
                        </div>
                        <el-table :data="pointList" border size="small" v-loading="pointLoading">
                            <el-table-column type="index" label="序号" width="60"></el-table-column>
                            <!-- <el-table-column label="上级点位" width="150">
                                <template slot-scope="scope">{{ scope.row.father_name || '电表' }}</template>
                            </el-table-column> -->
                            <el-table-column label="点位名称" min-width="180">
                                <template slot-scope="scope">
                                    <el-button type="text" @click="drillPoint(scope.row)">{{ (scope.row.father_name || '电表') + '至' + scope.row.name }}</el-button>
                                </template>
                            </el-table-column>
                            <el-table-column prop="create_time" label="创建时间" width="170"></el-table-column>
                            <el-table-column label="操作" width="210">
                                <template slot-scope="scope">
                                    <el-button type="text" size="small" @click="openPointForm(scope.row)" v-permision_tjtf="'edit'">修改</el-button>
                                    <el-button type="text" size="small" @click="deletePoint(scope.row)" v-permision_tjtf="'delete'">删除</el-button>
                                    <el-button type="text" size="small" @click="openMaterial(scope.row)" v-permision_tjtf="'material'">材料施工</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>

                    <!-- 点位拓扑图（4.4） -->
                    <el-tab-pane label="点位拓扑图" name="topo">
                        <div class="topo-toolbar">
                            <el-button size="small" @click="expandTopo(true)">一键展开</el-button>
                            <el-button size="small" @click="expandTopo(false)">一键收缩</el-button>
                        </div>
                        <el-tree ref="topoTree" :data="pointTreeData" :props="{ label: (data,node) => (data.father_name || '电表') + '至' + data.name , children: 'children' }"
                            node-key="ID" default-expand-all highlight-current></el-tree>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </el-drawer>

        <!-- 4.5 点位 新增/修改 Dialog -->
        <el-dialog :title="pointFormTitle" :visible.sync="pointFormVisible" width="460px" append-to-body>
            <el-form :model="pointForm" :rules="pointFormRules" ref="pointForm" label-width="110px">
                <el-form-item label="上级点位名称" prop="father_name">
                    <el-input v-model="pointForm.father_name" :disabled="pointForm.father_id > 0" placeholder="请输入初始点位名称"></el-input>
                </el-form-item>
                <el-form-item label="点位名称" prop="name">
                    <el-input v-model="pointForm.name" placeholder="请输入点位名称" clearable></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button @click="pointFormVisible = false">取消</el-button>
                <el-button type="primary" @click="submitPoint">保存</el-button>
            </span>
        </el-dialog>

        <!-- 4.6 点位材料施工 Drawer -->
        <el-drawer title="点位材料施工" :visible.sync="materialDrawerVisible" direction="rtl" size="65%" append-to-body
            @closed="closeMaterial">
            <div class="drawer-body" v-if="materialCurrentPoint && materialCurrentPoint.ID">
                <el-descriptions :column="2" border size="small" class="detail-desc">
                    <el-descriptions-item label="上级点位">{{ materialCurrentPoint.father_name || '电表' }}</el-descriptions-item>
                    <el-descriptions-item label="点位名称">{{ materialCurrentPoint.name }}</el-descriptions-item>
                </el-descriptions>

                <div class="material-toolbar">
                    <el-form :inline="true" size="small">
                        <el-form-item label="类型">
                            <el-select v-model="materialFilter.type" clearable placeholder="请选择" style="width: 130px;">
                                <el-option label="设备费" value="设备费"></el-option>
                                <el-option label="施工费" value="施工费"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="材料名称">
                            <el-input v-model="materialFilter.name" clearable placeholder="请输入" style="width: 150px;"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" icon="el-icon-search" @click="searchMaterial">查询</el-button>
                            <el-button type="success" icon="el-icon-plus" @click="openMaterialForm"
                                v-permision_tjtf="'add'">新增</el-button>
                        </el-form-item>
                    </el-form>
                </div>

                <el-table :data="materialList" border size="small" v-loading="materialLoading">
                    <el-table-column type="index" label="序号" width="55"></el-table-column>
                    <el-table-column prop="cur_category" label="类型" width="90"></el-table-column>
                    <el-table-column prop="cur_name" label="材料名称" min-width="140" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="cur_spec" label="规格型号" width="140" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="cur_unit" label="单位" width="80"></el-table-column>
                    <el-table-column prop="cur_price_cb" label="成本单价" width="100"></el-table-column>
                    <el-table-column prop="cur_price_sale" label="销售单价" width="100"></el-table-column>
                    <el-table-column prop="nums" label="数量" width="80"></el-table-column>
                    <el-table-column label="操作" width="140">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="openMaterialForm(scope.row)"
                                v-permision_tjtf="'edit'">修改</el-button>
                            <el-button type="text" size="small" @click="deleteMaterial(scope.row)"
                                v-permision_tjtf="'delete'">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <div class="material-pagination">
                    <el-pagination
                        background
                        layout="sizes,total,prev,pager,next,jumper"
                        :total="materialPage.total"
                        :page-size="materialPage.limit"
                        :page-sizes="[5, 10, 50, 100, 500, 1000]"
                        :current-page="materialPage.page"
                        @size-change="onMaterialSizeChange"
                        @current-change="onMaterialCurrentChange"
                    ></el-pagination>
                </div>
            </div>
        </el-drawer>

        <!-- 4.6 材料施工 新增/修改 Dialog -->
        <el-dialog :title="materialFormTitle" :visible.sync="materialFormVisible" width="480px" append-to-body>
            <el-form :model="materialForm" :rules="materialFormRules" ref="materialForm" label-width="100px">
                
                <el-form-item label="材料名称" prop="scan_material_id">
                    <el-select v-model="materialForm.scan_material_id" placeholder="请选择" filterable clearable
                        style="width: 100%;" @change="onMaterialChange">
                        <el-option v-for="m in materialOptions" :key="m.ID" :label="m.name+'(' + m.category + ')'" :value="m.ID"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="类型">
                    <el-input :value="materialForm.cur_category" disabled></el-input>
                </el-form-item>
                <el-form-item label="规格型号">
                    <el-input :value="materialForm.cur_spec" disabled></el-input>
                </el-form-item>
                <el-form-item label="单位">
                    <el-input :value="materialForm.cur_unit" disabled></el-input>
                </el-form-item>
                <el-form-item label="成本单价">
                    <el-input :value="materialForm.cur_price_cb" disabled></el-input>
                </el-form-item>
                <el-form-item label="销售单价">
                    <el-input :value="materialForm.cur_price_sale" disabled></el-input>
                </el-form-item>
                <el-form-item label="数量" prop="count">
                    <el-input v-model.number="materialForm.nums" type="number" placeholder="请输入数量"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button @click="materialFormVisible = false">取消</el-button>
                <el-button type="primary" @click="submitMaterial">保存</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import pageMixin from "@/mixins/pageMixin"
import { mapGetters } from "vuex"
import {
    getScanProjectListApi,
    addScanProjectApi,
    updateScanProjectApi,
    deleteScanProjectApi,
    getScanProjectItemListApi,
    getScanProjectItemTreeApi,
    addScanProjectItemApi,
    updateScanProjectItemApi,
    deleteScanProjectItemApi,
    getScanProjectStatApi,
    getScanMaterialListApi,
    getScanProjectItemMaterialListApi,
    addScanProjectItemMaterialApi,
    updateScanProjectItemMaterialApi,
    deleteScanProjectItemMaterialApi
} from "@/api/scan.js"
import { getCommunityList } from "@/api/dev_archive.js"
import { getDictDataByTypeApi } from "@/api/dict.js"

const NUM_FIELDS = [
    'transformer_ground', 'transformer_down_ground', 'building_count', 'house_total',
    'house_occupied', 'park_up_cout', 'park_down_cout', 'park_solded_count',
    'vehicle_total', 'vehicle_ev_total'
]

export default {
    name: 'PojectManage',
    mixins: [pageMixin],
    data() {
        return {
            selectedRowKey: null,
            tableColumnAlign: true,
            filter: {
                name: '',
                project_type: '',
                community_id: '',
                dateRange: []
            },
            loading: false,
            tableData: [],

            // 4.3 统计区
            statLoading: false,
            statData: {},
            statItems: [
                { key: 'transformer_ground', label: '地面变压器数量' },
                { key: 'transformer_down_ground', label: '地下车库变压器数量' },
                { key: 'building_count', label: '住宅栋数' },
                { key: 'house_total', label: '规划总户数' },
                { key: 'house_occupied', label: '入住户数' },
                { key: 'park_up_cout', label: '地面车位数' },
                { key: 'park_down_cout', label: '地下车位数' },
                { key: 'park_solded_count', label: '已售车位数' },
                { key: 'vehicle_total', label: '车辆总数' },
                { key: 'vehicle_ev_total', label: '电动汽车总数' }
            ],

            // 下拉选项
            projectTypeOptions: [],
            communityOptions: [],

            // 4.2 项目新增/修改
            projectDrawerVisible: false,
            projectDrawerTitle: '新增项目',
            projectForm: this.getProjectForm(),
            projectFormRules: {
                name: [{ required: true, message: '请输入项目名称', trigger: 'blur' }],
                project_type: [{ required: true, message: '请选择项目类型', trigger: 'change' }],
                community_id: [{ required: true, message: '请选择所属社区', trigger: 'change' }]
            },

            // 4.4 项目详情
            detailDrawerVisible: false,
            detailData: {},
            detailActiveTab: 'info',

            // 4.5 点位管理
            pointBreadcrumb: [],
            pointParent: null,
            pointList: [],
            pointLoading: false,
            pointFormVisible: false,
            pointFormTitle: '新增点位',
            pointForm: this.getPointForm(),
            pointFormRules: {
                name: [{ required: true, message: '请输入点位名称', trigger: 'blur' }],
                father_name: [{ required: true, message: '请输入上级点位名称', trigger: 'blur' }]
            },
            pointTreeData: [],

            // 4.6 点位材料施工
            materialDrawerVisible: false,
            materialCurrentPoint: {},
            materialFilter: { name: '', type: '' },
            materialList: [],
            materialLoading: false,
            materialPage: { page: 1, limit: 10, total: 0 },
            materialOptions: [],
            materialFormVisible: false,
            materialFormTitle: '新增材料施工',
            materialForm: this.getMaterialForm(),
            materialFormRules: {
                cur_category: [{ required: true, message: '请选择类型', trigger: 'change' }],
                scan_material_id: [{ required: true, message: '请选择材料', trigger: 'change' }],
                nums: [{ required: true, message: '请输入数量', trigger: 'blur' }]
            }
        }
    },
    created() {
        this.loadProjectTypes()
        this.loadCommunities()
        this.getData()
    },
    methods: {
        /* ============ 列表 + 统计（4.3） ============ */
        getProjectForm() {
            return {
                name: '',
                project_type: '',
                project_type_name: '',
                community_id: '',
                community_name: '',
                transformer_type: '',
                transformer_ground: '',
                transformer_down_ground: '',
                building_count: '',
                house_total: '',
                house_occupied: '',
                park_up_cout: '',
                park_down_cout: '',
                park_solded_count: '',
                vehicle_total: '',
                vehicle_ev_total: '',
                remark: ''
            }
        },
        getPointForm() {
            return { ID: '', name: '', father_id: null,father_name: '', scan_project_id: '' }
        },
        getMaterialForm() {
            return {
                cur_category: '', scan_material_id: '', cur_name: '',
                cur_spec: '', cur_unit: '', cur_price_cb: '', cur_price_sale: '', nums: ''
            }
        },
        buildFilterParams() {
            const [start_time, end_time] = (this.filter.dateRange && this.filter.dateRange.length === 2)
                ? this.filter.dateRange : ['', '']
            return {
                name: this.filter.name || null,
                project_type: this.filter.project_type || null,
                community_id: this.filter.community_id || null,
                start_time: start_time || null,
                end_time: end_time || null
            }
        },
        getData() {
            this.loading = true
            const params = {
                page: this.pageParams.page,
                pagesize: this.pageParams.limit,
                ...this.buildFilterParams()
            }
            getScanProjectListApi(params)
                .then((res) => {
                    this.tableData = res.data || []
                    this.pageParams.total = res.total || 0
                })
                .catch(() => {
                    this.$message.error('获取项目列表失败')
                })
                .finally(() => {
                    this.loading = false
                })
            //this.fetchStat(params)
        },
        fetchStat(params) {
            this.statLoading = true
            const statParams = { ...params }
            delete statParams.page
            delete statParams.pagesize
            getScanProjectStatApi(statParams)
                .then((res) => {
                    this.statData = (res && res.data) ? res.data : (res || {})
                })
                .catch(() => {
                    this.statData = this.sumLocal()
                })
                .finally(() => {
                    this.statLoading = false
                })
        },
        sumLocal() {
            const r = {}
            this.statItems.forEach(s => {
                r[s.key] = this.tableData.reduce((a, b) => a + (Number(b[s.key]) || 0), 0)
            })
            return r
        },
        handleRowClick(row) {
            this.selectedRowKey = row.id
        },

        /* ============ 名称解析 ============ */
        getTypeName(val) {
            if (!val) return '-'
            const f = this.projectTypeOptions.find(t => String(t.id) === String(val))
            return f ? f.name : val
        },
        getCommunityName(val) {
            if (!val) return '-'
            const f = this.communityOptions.find(c => c.ID === val)
            return f ? f.name : val
        },
        findTypeId(name) {
            const f = this.projectTypeOptions.find(t => t.name === name)
            return f ? f.id : ''
        },
        findCommunityId(name) {
            const f = this.communityOptions.find(c => c.name === name)
            return f ? f.ID : ''
        },

        /* ============ 下拉数据 ============ */
        loadProjectTypes() {
            getDictDataByTypeApi({ dict_type: 'SCAN_PROJECT_TYPE' })
                .then((res) => {
                    const list = (res && res.data) || []
                    this.projectTypeOptions = list.map((d) => ({
                        id: d.dict_value,
                        name: d.dict_label,
                        dictValue: d.dict_value,
                        dictLabel: d.dict_label
                    }))
                })
                .catch(() => { })
        },
        loadCommunities() {
            getCommunityList({ page: 1, pagesize: 1000 })
                .then((res) => {
                    this.communityOptions = res.data || []
                })
                .catch(() => { })
        },

        /* ============ 4.2 项目 新增/修改 ============ */
        addProject() {
            this.projectDrawerTitle = '新增项目'
            this.projectForm = this.getProjectForm()
            this.projectDrawerVisible = true
        },
        updateProject(row) {
            this.projectDrawerTitle = '修改项目'
            this.projectForm = {
                ...this.getProjectForm(),
                ID: row.ID,
                name: row.name,
                project_type: row.project_type != null ? row.project_type : this.findTypeId(row.project_type_name),
                project_type_name: row.project_type_name || '',
                community_id: row.community_id != null ? row.community_id : this.findCommunityId(row.community_name),
                community_name: row.community_name || '',
                transformer_type: row.transformer_type,
                transformer_ground: row.transformer_ground,
                transformer_down_ground: row.transformer_down_ground,
                building_count: row.building_count,
                house_total: row.house_total,
                house_occupied: row.house_occupied,
                park_up_cout: row.park_up_cout,
                park_down_cout: row.park_down_cout,
                park_solded_count: row.park_solded_count,
                vehicle_total: row.vehicle_total,
                vehicle_ev_total: row.vehicle_ev_total,
                remark: row.remark
            }
            this.projectDrawerVisible = true
        },
        onProjectTypeChange(id) {
            const f = this.projectTypeOptions.find(t => t.id === id)
            this.projectForm.project_type_name = f ? f.name : ''
        },
        onCommunityChange(id) {
            const f = this.communityOptions.find(c => c.ID === id)
            this.projectForm.community_name = f ? f.name : ''
        },
        submitProject() {
            this.$refs.projectForm.validate((valid) => {
                if (!valid) return
                const params = { ...this.projectForm }
                NUM_FIELDS.forEach(k => {
                    params[k] = (params[k] === '' || params[k] == null) ? 0 : Number(params[k])
                })
                //console.log(params['project_type'])
                const numKeyArray = ['community_id','project_type']
                numKeyArray.forEach(k => {
                    console.log(k,params[k])
                    params[k] = (params[k] === '' || params[k] == null) ? 0 : Number(params[k])
                })
                const isEdit = !!params.ID
                const api = isEdit ? updateScanProjectApi : addScanProjectApi
                api(params)
                    .then(() => {
                        this.$message.success(isEdit ? '修改成功' : '新增成功')
                        this.projectDrawerVisible = false
                        this.getData()
                    })
                    .catch(() => { })
            })
        },
        resetProjectForm() {
            this.projectForm = this.getProjectForm()
            if (this.$refs.projectForm) {
                this.$refs.projectForm.clearValidate()
            }
        },
        deleteProject(row) {
            this.$confirm(`确认删除项目「${row.name}」吗？`, '提示', {
                type: 'warning'
            }).then(() => {
                return deleteScanProjectApi({ id: row.id })
            }).then(() => {
                this.$message.success('删除成功')
                this.getData()
            }).catch(() => { })
        },

        /* ============ 4.4 项目详情 ============ */
        detailsProject(row) {
            this.detailData = { ...row }
            this.detailActiveTab = 'info'
            this.detailDrawerVisible = true
            this.goPointRoot(row.ID)
            this.loadAllPointsForTopo(row.ID)
        },
        closeDetail() {
            this.detailData = {}
            this.pointBreadcrumb = []
            this.pointParent = null
            this.pointList = []
            this.pointTreeData = []
            this.materialCurrentPoint = {}
        },

        /* ============ 4.5 点位管理 ============ */
        goPointRoot(projectId) {
            const pid = projectId || (this.detailData && this.detailData.ID)
            this.pointBreadcrumb = []
            this.pointParent = null
            if (pid) this.loadPoints(pid, null)
        },
        loadPoints(projectId, parentId) {
            this.pointLoading = true
            getScanProjectItemListApi({
                scan_project_id: projectId ? Number(projectId) : 0,
                father_id: parentId ? Number(parentId) : 0,
                page: 1,
                pagesize: 1000
            }).then((res) => {
                this.pointList = res.data || []
            }).catch(() => { }).finally(() => {
                this.pointLoading = false
            })
        },
        drillPoint(row) {
            this.pointBreadcrumb.push({ ID: row.ID, name: row.name , father_name: row.father_name })
            this.pointParent = row
            this.loadPoints(this.detailData.ID, row.ID)
        },
        goPointLevel(index) {
            this.pointBreadcrumb = this.pointBreadcrumb.slice(0, index + 1)
            this.pointParent = this.pointBreadcrumb[index] || null
            this.loadPoints(this.detailData.ID, this.pointParent ? this.pointParent.ID : 0)
        },
        openPointForm(row) {
            if (row) {
                this.pointFormTitle = '修改点位'
                this.pointForm = {
                    ID: row.ID,
                    name: row.name,
                    father_name: row.father_name,
                    father_id: this.pointParent ? this.pointParent.ID : 0,
                    scan_project_id: this.detailData.ID
                }
            } else {
                this.pointFormTitle = '新增点位'
                this.pointForm = {
                    name: '',
                    father_name: this.pointParent ? this.pointParent.name : '电表',
                    father_id: this.pointParent ? this.pointParent.ID : 0,
                    scan_project_id: this.detailData.ID
                }
            }
            this.pointFormVisible = true
        },
        submitPoint() {
            this.$refs.pointForm.validate((valid) => {
                if (!valid) return
                const params = { ...this.pointForm }
                if (!params.father_id) params.father_id = 0
                const isEdit = !!params.ID
                const api = isEdit ? updateScanProjectItemApi : addScanProjectItemApi
                api(params).then(() => {
                    this.$message.success(isEdit ? '修改成功' : '新增成功')
                    this.pointFormVisible = false
                    this.loadPoints(this.detailData.ID, this.pointParent ? this.pointParent.ID : 0)
                    this.loadAllPointsForTopo(this.detailData.ID)
                }).catch(() => { })
            })
        },
        deletePoint(row) {
            this.$confirm(`确认删除点位「${row.name}」吗？`, '提示', {
                type: 'warning'
            }).then(() => {
                return deleteScanProjectItemApi({ ID: row.ID })
            }).then(() => {
                this.$message.success('删除成功')
                this.loadPoints(this.detailData.ID, this.pointParent ? this.pointParent.ID : 0)
                this.loadAllPointsForTopo(this.detailData.ID)
            }).catch(() => { })
        },

        /* ============ 4.4 点位拓扑图 ============ */
        loadAllPointsForTopo(projectId) {
            getScanProjectItemTreeApi({
                scan_project_id: projectId ? Number(projectId) : 0,
                page: 1,
                pagesize: 100000
            }).then((res) => {
                //this.pointTreeData = this.buildTree(res.data || [])
                this.pointTreeData = res.data || []
            }).catch(() => { })
        },
        buildTree(list) {
            const map = {}
            const roots = []
            list.forEach(item => { map[item.ID] = { ...item, children: [] } })
            list.forEach(item => {
                const node = map[item.ID]
                if (item.father_id && map[item.father_id]) {
                    map[item.father_id].children.push(node)
                } else {
                    roots.push(node)
                }
            })
            console.log(roots)
            return roots
        },
        expandTopo(expanded) {
            const tree = this.$refs.topoTree
            if (!tree) return
            const nodes = tree.store._getAllNodes()
            nodes.forEach(n => { n.expanded = expanded })
        },

        /* ============ 4.6 点位材料施工 ============ */
        openMaterial(row) {
            this.materialCurrentPoint = { ...row }
            this.materialDrawerVisible = true
            this.materialFilter = { name: '', type: '' }
            this.loadMaterialOptions()
            this.searchMaterial()
        },
        loadMaterialOptions() {
            getScanMaterialListApi({ page: 1, pagesize: 1000 })
                .then((res) => {
                    this.materialOptions = res.data || []
                })
                .catch(() => { })
        },
        searchMaterial(resetPage = true) {
            if (resetPage) this.materialPage.page = 1
            this.materialLoading = true
            const params = {
                scan_project_item_id: this.materialCurrentPoint.ID,
                category: this.materialFilter.type || null,
                name: this.materialFilter.name || null,
                page: this.materialPage.page,
                pagesize: this.materialPage.limit
            }
            getScanProjectItemMaterialListApi(params)
                .then((res) => {
                    this.materialList = res.data || []
                    this.materialPage.total = res.count || res.total || 0
                })
                .catch(() => { })
                .finally(() => {
                    this.materialLoading = false
                })
        },
        onMaterialSizeChange(val) {
            this.materialPage.limit = val
            this.materialPage.page = 1
            this.searchMaterial(false)
        },
        onMaterialCurrentChange(val) {
            this.materialPage.page = val
            this.searchMaterial(false)
        },
        onMaterialChange(ID) {
            const m = this.materialOptions.find(x => x.ID === ID)
            if (m) {
                this.materialForm.cur_name = m.name
                this.materialForm.scan_material_id = m.ID
                this.materialForm.cur_spec = m.spec
                this.materialForm.cur_unit = m.unit
                this.materialForm.cur_price_cb = m.price_cb
                this.materialForm.cur_price_sale = m.price_sale
                this.materialForm.cur_category = m.category
            }
        },
        openMaterialForm(row) {
            if (row) {
                // 修改：回显数据，并以大写 ID 携带记录主键（getMaterialForm 不含 ID，避免新增时误传）
                this.materialFormTitle = '修改材料施工'
                this.materialForm = {
                    ID: row.ID,
                    cur_category: row.cur_category || '',
                    scan_material_id: row.scan_material_id != null ? row.scan_material_id : '',
                    cur_name: row.cur_name || '',
                    cur_spec: row.cur_spec || '',
                    cur_unit: row.cur_unit || '',
                    cur_price_cb: row.cur_price_cb || '',
                    cur_price_sale: row.cur_price_sale || '',
                    nums: row.nums != null ? row.nums : ''
                }
            } else {
                this.materialFormTitle = '新增材料施工'
                this.materialForm = this.getMaterialForm()
            }
            this.materialFormVisible = true
        },
        submitMaterial() {
            this.$refs.materialForm.validate((valid) => {
                if (!valid) return
                const params = {
                    ...this.materialForm,
                    scan_project_item_id: this.materialCurrentPoint.ID,
                    nums: Number(this.materialForm.nums)
                }
                // 仅当表单携带大写 ID 时为修改，否则为新增（保证新增不传 ID）
                const isEdit = !!this.materialForm.ID
                const api = isEdit ? updateScanProjectItemMaterialApi : addScanProjectItemMaterialApi
                api(params)
                    .then(() => {
                        this.$message.success(isEdit ? '修改成功' : '新增成功')
                        this.materialFormVisible = false
                        this.searchMaterial()
                    })
                    .catch(() => { })
            })
        },
        deleteMaterial(row) {
            this.$confirm('确认删除该材料施工记录吗？', '提示', {
                type: 'warning'
            }).then(() => {
                return deleteScanProjectItemMaterialApi({ id: row.ID })
            }).then(() => {
                this.$message.success('删除成功')
                this.searchMaterial()
            }).catch(() => { })
        },
        closeMaterial() {
            this.materialCurrentPoint = {}
        }
    }
}
</script>

<style scoped lang="scss">
.app-container {
    height: calc(100vh - 120px);
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px;
    overflow: hidden;
    box-sizing: border-box;
}

.search-card {
    flex-shrink: 0;

    ::v-deep .el-card__body {
        padding: 12px 16px;
    }
}

.stat-card {
    flex-shrink: 0;

    ::v-deep .el-card__body {
        padding: 10px 16px;
        display: flex;
        flex-wrap: wrap;
        gap: 10px 24px;
    }

    .stat-item {
        display: flex;
        align-items: baseline;
        gap: 6px;
        font-size: 13px;

        .stat-label {
            color: #909399;
        }

        .stat-value {
            color: #303133;
            font-weight: 600;
            font-family: monospace;
        }
    }
}

.table-card {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;

    ::v-deep .el-card__body {
        flex: 1;
        display: flex;
        flex-direction: column;
        padding: 12px;
        overflow: hidden;
    }
}

.my-pagination {
    margin-top: 20px;
    text-align: right;
    flex-shrink: 0;
}

.table-header-cell {
    background-color: #f5f7fa;
    color: #606266;
    font-weight: 600;
}

.drawer-body {
    padding: 8px 16px;

    .toolbar {
        margin-bottom: 12px;
    }
}

.detail-desc {
    margin-bottom: 12px;
}

.detail-tabs {
    margin-top: 8px;
}

.point-toolbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;

    ::v-deep .el-breadcrumb {
        font-size: 13px;
    }
}

.topo-toolbar {
    margin-bottom: 10px;
}

.material-toolbar {
    margin: 12px 0;

    ::v-deep .el-form-item {
        margin-bottom: 0;
    }
}

.material-pagination {
    margin-top: 12px;
    text-align: right;
}
</style>
